const formatAccount = (num: any) => {
  return num?.toString()?.padStart(5, "0");
};

export default formatAccount;
